// src/components/AudioLoadingIndicator.tsx
import React from 'react';
import { Volume2 } from '@/components/ui/lucide-memo'; // Or any other suitable icon like Headphones, AudioLines

const AudioLoadingIndicator: React.FC = React.memo(() => {
  return (
    <div
      className="absolute top-1 right-1 p-0.5 bg-black/50 rounded-full animate-pulse"
      title="Audio loading..."
    >
      <Volume2 size={12} color="white" strokeWidth={2} />
    </div>
  );
});

AudioLoadingIndicator.displayName = 'AudioLoadingIndicator';
export default AudioLoadingIndicator;